import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as loginApi, register as registerApi, verifyOtp as verifyOtpApi, resendOtp as resendOtpApi, forgotPassword as forgotPasswordApi, resetPassword as resetPasswordApi } from '../services/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                setUser(JSON.parse(storedUser));
            }
        } catch (error) {
            console.error('Error parsing stored user:', error);
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        } finally {
            setLoading(false);
        }
    }, []);

    const login = async (credentials) => {
        const data = await loginApi(credentials);
        setUser(data.user);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        return data;
    };

    const register = async (userData) => {
        return await registerApi(userData);
    };

    const verifyOtp = async (otpData) => {
        const data = await verifyOtpApi(otpData);
        setUser(data.user);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        return data;
    };

    const resendOtp = async (email) => {
        return await resendOtpApi(email);
    };

    const forgotPassword = async (email) => {
        return await forgotPasswordApi(email);
    };

    const resetPassword = async (resetData) => {
        const data = await resetPasswordApi(resetData);
        setUser(data.user);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        return data;
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, verifyOtp, resendOtp, forgotPassword, resetPassword, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
